export const STATUS_COURSES = "STATUS_COURSES";
export const FETCH_COURSES = "FETCH_COURSES";
export const WATCH_COURSE = "WATCH_COURSE";
export const MESSAGE_COURSE = "MESSAGE_COURSE";
export const STATUS_ORDERS = "STATUS_ORDERS";
export const FETCH_ORDERS = "FETCH_ORDERS";
export const MESSAGE_ORDER = "MESSAGE_ORDER";
export const POPULATE_PROFILE = "POPULATE_PROFILE";
